import cn from "classnames";

import type { ReactNode } from "react";

import { StatusIcon } from "@/components/statusIcon/statusIcon.component";

import {
  FEATURE_BLOCK_STYLE_CONFIG,
  getFeatureBlockTextClassName,
  type FeatureBlockStyleValue,
} from "./featureBlockStyles.config";

export function FeatureListItem({ style, children }: FeatureListItemProps) {
  const config = FEATURE_BLOCK_STYLE_CONFIG[style];
  const isThinCheck = style === "featureThinCheck";

  return (
    <li
      className={cn(
        "rich-text-feature-icon-item w-full list-none max-lg:text-left!",
          {
          "rich-text-feature-thin-check relative pl-9 [&+[data-testid=text]]:pl-9 [&+p]:pl-9": isThinCheck,
          "flex items-start gap-3": !isThinCheck
          },
      )}>
      {isThinCheck ? (
        <span className="absolute top-0 left-0">
          <StatusIcon variant={config.variant} srOnlyLabel={config.srOnlyLabel} />
        </span>
      ) : (
        <StatusIcon variant={config.variant} srOnlyLabel={config.srOnlyLabel} />
      )}
      <div className={getFeatureBlockTextClassName(config)}>{children}</div>
    </li>
  );
}

type FeatureListItemProps = {
  style: FeatureBlockStyleValue;
  children: ReactNode;
};
